/**
 * DJI-style model picker for /pages/tire-compare — dropdown per column, no size search.
 */
(function () {
  var API = "/apps/specr/api/tire-compare-catalog";
  var COLLECTION_FALLBACK = "/collections/tires/products.json?limit=250";
  var MAX = 4;
  var SLOTS = MAX;

  var pickerRoot = document.getElementById("tire-compare-picker");
  var colsEl = document.getElementById("tire-compare-columns");
  var loadingEl = document.getElementById("tire-compare-catalog-loading");
  var errorEl = document.getElementById("tire-compare-catalog-error");
  var emptyEl = document.getElementById("tire-compare-empty");

  if (!pickerRoot || !colsEl || !window.SpecrTireCompare) return;

  var catalog = [];
  var catalogByHandle = {};
  var slotHandles = ["", "", "", ""];

  var TIRE_ICON =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="9"/><circle cx="12" cy="12" r="3"/></svg>';

  function escHtml(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function hide(el) {
    if (el) el.hidden = true;
  }

  function show(el) {
    if (el) el.hidden = false;
  }

  function priceLabel(entry) {
    if (entry.minPrice == null || isNaN(entry.minPrice)) return "—";
    if (entry.sizeCount > 1) return "From $" + entry.minPrice.toFixed(2);
    return "$" + entry.minPrice.toFixed(2);
  }

  function catalogToCompareItem(entry) {
    return {
      variantId: String(entry.variantId),
      title: entry.label,
      size: entry.size,
      price: priceLabel(entry),
      priceNum: entry.minPrice,
      url: entry.url,
      season: entry.season || "",
      speedLoad: entry.speedLoad || "",
      utqg: entry.utqg || "",
      studdable: entry.studdable || "",
      runFlat: entry.runFlat || "",
      handle: entry.handle,
      variants: entry.variants || [],
    };
  }

  function vendorsGrouped() {
    var map = {};
    catalog.forEach(function (entry) {
      var v = entry.vendor || "Other";
      if (!map[v]) map[v] = [];
      map[v].push(entry);
    });
    return Object.keys(map)
      .sort(function (a, b) {
        return a.localeCompare(b);
      })
      .map(function (vendor) {
        return { vendor: vendor, items: map[vendor] };
      });
  }

  function buildSelectOptions(selectedHandle, slotIndex) {
    var usedElsewhere = {};
    slotHandles.forEach(function (h, i) {
      if (i !== slotIndex && h) usedElsewhere[h] = true;
    });

    var html = '<option value="">Choose a model</option>';
    vendorsGrouped().forEach(function (group) {
      html += '<optgroup label="' + escHtml(group.vendor) + '">';
      group.items.forEach(function (entry) {
        var disabled = usedElsewhere[entry.handle] && entry.handle !== selectedHandle;
        html +=
          '<option value="' +
          escHtml(entry.handle) +
          '"' +
          (entry.handle === selectedHandle ? " selected" : "") +
          (disabled ? " disabled" : "") +
          ">" +
          escHtml(entry.title) +
          "</option>";
      });
      html += "</optgroup>";
    });
    return html;
  }

  function buildColumnMedia(entry) {
    if (entry.imageUrl) {
      return (
        '<img src="' +
        escHtml(entry.imageUrl) +
        '" alt="' +
        escHtml(entry.imageAlt || entry.title) +
        '" loading="lazy" decoding="async" data-compare-product-img />'
      );
    }
    return (
      '<div class="tire-compare-col__media-fallback" data-tire-brand-fallback data-vendor="' +
      escHtml(entry.vendor || "") +
      '">' +
      TIRE_ICON +
      "</div>"
    );
  }

  function renderColumnCard(slotIndex) {
    var card = colsEl.querySelector('[data-compare-slot-card="' + slotIndex + '"]');
    if (!card) return;

    var handle = slotHandles[slotIndex];
    var entry = handle ? catalogByHandle[handle] : null;

    if (!entry) {
      card.innerHTML =
        '<div class="tire-compare-col__placeholder">' +
        '<div class="tire-compare-col__placeholder-icon">' +
        TIRE_ICON +
        "</div>" +
        "<p>Select a model to compare</p>" +
        "</div>";
      return;
    }

    var mediaHtml = buildColumnMedia(entry);

    card.innerHTML =
      '<a class="tire-compare-col__media" href="' +
      escHtml(entry.url) +
      '">' +
      mediaHtml +
      "</a>" +
      '<p class="tire-compare-col__price">' +
      escHtml(priceLabel(entry)) +
      "</p>" +
      '<a class="tire-compare-col__link" href="' +
      escHtml(entry.url) +
      '">View tire</a>';

    if (typeof window.applyTireBrandLogos === "function") {
      window.applyTireBrandLogos(card);
    }

    var img = card.querySelector("[data-compare-product-img]");
    if (img) {
      img.addEventListener("error", function onImgError() {
        img.removeEventListener("error", onImgError);
        var media = card.querySelector(".tire-compare-col__media");
        if (!media) return;
        media.innerHTML =
          '<div class="tire-compare-col__media-fallback" data-tire-brand-fallback data-vendor="' +
          escHtml(entry.vendor || "") +
          '">' +
          TIRE_ICON +
          "</div>";
        if (typeof window.applyTireBrandLogos === "function") {
          window.applyTireBrandLogos(card);
        }
      });
    }
  }

  function renderColumns() {
    colsEl.innerHTML = "";
    for (var i = 0; i < SLOTS; i++) {
      var col = document.createElement("div");
      col.className = "tire-compare-col";
      col.innerHTML =
        '<label class="visually-hidden" for="tire-compare-select-' +
        i +
        '">Compare slot ' +
        (i + 1) +
        "</label>" +
        '<select id="tire-compare-select-' +
        i +
        '" class="tire-compare-col__select" data-compare-slot="' +
        i +
        '">' +
        buildSelectOptions(slotHandles[i], i) +
        "</select>" +
        '<div class="tire-compare-col__card" data-compare-slot-card="' +
        i +
        '"></div>';

      colsEl.appendChild(col);
      renderColumnCard(i);
    }

    colsEl.querySelectorAll("[data-compare-slot]").forEach(function (sel) {
      sel.addEventListener("change", function () {
        var idx = parseInt(sel.getAttribute("data-compare-slot"), 10);
        slotHandles[idx] = sel.value || "";
        syncCompareList();
        renderColumns();
      });
    });
  }

  function syncCompareList() {
    var items = slotHandles
      .filter(Boolean)
      .map(function (handle) {
        return catalogByHandle[handle];
      })
      .filter(Boolean)
      .map(catalogToCompareItem);

    window.SpecrTireCompare.replace(items);

    if (emptyEl) {
      emptyEl.hidden = items.length > 0;
    }
  }

  function seedFromStorage() {
    var saved = window.SpecrTireCompare.list();
    saved.slice(0, SLOTS).forEach(function (item, i) {
      var handle = item.handle;
      if (!handle && item.url) {
        var m = String(item.url).match(/\/products\/([^/?#]+)/);
        if (m) handle = m[1];
      }
      if (handle && catalogByHandle[handle]) {
        slotHandles[i] = handle;
      }
    });
  }

  function normalizeCatalogEntry(raw) {
    var handle = raw.handle;
    if (!handle) return null;
    var minPrice =
      raw.minPrice != null
        ? raw.minPrice
        : raw.price != null
          ? parseFloat(String(raw.price).replace(/[^\d.]/g, ""))
          : null;
    var variantId = raw.variantId;
    if (!variantId && raw.variants && raw.variants[0]) {
      variantId = String(raw.variants[0].variantId || raw.variants[0].id);
    }
    var label =
      raw.label ||
      ((raw.vendor ? raw.vendor + " " : "") + (raw.title || "")).trim();
    return {
      handle: handle,
      title: raw.title || label,
      vendor: raw.vendor || "",
      label: label,
      imageUrl:
        raw.imageUrl ||
        raw.featured_image ||
        (raw.images && raw.images[0]
          ? raw.images[0].src || raw.images[0]
          : ""),
      imageAlt: raw.imageAlt || raw.title || "",
      minPrice: minPrice != null && !isNaN(minPrice) ? minPrice : null,
      variantId: variantId || handle,
      size: raw.size || "Various sizes",
      sizeCount: raw.sizeCount || 1,
      season: raw.season || "",
      speedLoad: raw.speedLoad || "",
      utqg: raw.utqg || "",
      studdable: raw.studdable || "",
      runFlat: raw.runFlat || "",
      url: raw.url || "/products/" + handle,
      variants: Array.isArray(raw.variants)
        ? raw.variants.map(function (v) {
            return {
              variantId: String(v.variantId || v.id),
              tireSize: v.tireSize || v.size || "",
              price: v.price != null && !isNaN(Number(v.price)) ? Number(v.price) : null,
              season: v.season || "",
              speedLoad: v.speedLoad || "",
              utqg: v.utqg || "",
              studdable: v.studdable || "",
              runFlat: v.runFlat || "",
              available: v.available !== false,
            };
          })
        : [],
    };
  }

  function indexCatalog(list) {
    catalog = list;
    catalogByHandle = {};
    catalog.forEach(function (entry) {
      catalogByHandle[entry.handle] = entry;
    });
  }

  function loadFromCollection() {
    return fetch(COLLECTION_FALLBACK, { headers: { Accept: "application/json" } })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        var products = (data && data.products) || [];
        return products
          .map(function (p) {
            var v = (p.variants && p.variants[0]) || null;
            var price = v ? parseFloat(v.price) : null;
            return normalizeCatalogEntry({
              handle: p.handle,
              title: p.title,
              vendor: p.vendor,
              minPrice: price,
              variantId: v ? v.id : p.handle,
              imageUrl: p.featured_image,
              size: "Various sizes",
              url: "/products/" + p.handle,
            });
          })
          .filter(Boolean);
      });
  }

  function enrichCatalogImagesFromStorefront() {
    var pending = catalog.filter(function (entry) {
      return !entry.imageUrl && entry.handle;
    });
    if (!pending.length) return Promise.resolve();

    return Promise.all(
      pending.map(function (entry) {
        return fetch("/products/" + encodeURIComponent(entry.handle) + ".js", {
          headers: { Accept: "application/json" },
        })
          .then(function (res) {
            return res.ok ? res.json() : null;
          })
          .then(function (product) {
            if (!product) return;
            var imageUrl =
              product.featured_image ||
              (product.media && product.media[0] ? product.media[0].preview_image.src : "") ||
              (product.images && product.images[0] ? product.images[0] : "");
            if (!imageUrl) return;
            entry.imageUrl = imageUrl;
            entry.imageAlt = product.title || entry.title;
            catalogByHandle[entry.handle] = entry;
          })
          .catch(function () {});
      })
    ).then(function () {
      if (colsEl && !colsEl.hidden) renderColumns();
    });
  }

  function initCatalog(list) {
    indexCatalog(list);
    seedFromStorage();
    syncCompareList();
    hide(loadingEl);
    show(colsEl);
    renderColumns();
    enrichCatalogImagesFromStorefront();
  }

  function showError(msg) {
    hide(loadingEl);
    if (errorEl) {
      errorEl.textContent = msg;
      show(errorEl);
    }
  }

  fetch(API, { headers: { Accept: "application/json" } })
    .then(function (res) {
      return res.json().then(function (data) {
        return { ok: res.ok, data: data };
      });
    })
    .then(function (out) {
      var products = (out.data && out.data.products) || [];
      if (out.ok && products.length) {
        initCatalog(products.map(normalizeCatalogEntry).filter(Boolean));
        return;
      }
      return loadFromCollection().then(function (fallback) {
        if (fallback.length) {
          initCatalog(fallback);
        } else {
          showError(
            (out.data && out.data.error) ||
              "Could not load tire models. Try again or add tires from search results."
          );
        }
      });
    })
    .catch(function () {
      loadFromCollection()
        .then(function (fallback) {
          if (fallback.length) initCatalog(fallback);
          else showError("Could not load tire models. Check your connection and try again.");
        })
        .catch(function () {
          showError("Could not load tire models. Check your connection and try again.");
        });
    });

  window.addEventListener("specr:tire-compare-changed", function () {
    syncSlotsFromStorage();
  });

  function syncSlotsFromStorage() {
    if (!catalog.length) return;
    var saved = window.SpecrTireCompare.list();
    var newHandles = ["", "", "", ""];
    saved.slice(0, SLOTS).forEach(function (item, i) {
      var handle = item.handle;
      if (!handle && item.url) {
        var m = String(item.url).match(/\/products\/([^/?#]+)/);
        if (m) handle = m[1];
      }
      if (handle && catalogByHandle[handle]) newHandles[i] = handle;
    });
    var changed = newHandles.some(function (h, i) {
      return h !== slotHandles[i];
    });
    slotHandles = newHandles;
    if (changed && colsEl && !colsEl.hidden) renderColumns();
    if (emptyEl) emptyEl.hidden = saved.length > 0;
  }
})();
